import { Card, Stack, Title, Input, useTheme } from "@introist/react-foundation/v2";
import { HtmlEditor } from "components/editors/v4/HtmlEditor/HtmlEditor";

export interface FormDetailsSettingsProps {
  title: string;
  description: string;
  onChange: (title: string, description: string) => void;
}

const SLACK_TITLE_CHARACTER_LIMIT = 25;

export const FormDetailsSettings = ({ title, description, onChange }: FormDetailsSettingsProps) => {
  const { theme } = useTheme();
  const characterCount = title.length;
  const isOverLimit = characterCount > SLACK_TITLE_CHARACTER_LIMIT;
  return (
    <Card style={{ padding: "var(--spacing-medium)" }}>
      <Stack vertical gap="medium">
        <Title variant="bold">Form Details</Title>

        {/* Title */}
        <Stack vertical gap="xSmall">
          <Title style={{ fontSize: "14px" }}>Title</Title>
          <Input
            value={title}
            onChange={value => onChange(value, description)}
            placeholder="Enter form title"
            size="small"
          />
          {/* Count characters and show warning if more than 25 as it won't work in Slack */}
          <Stack justifyContent="flex-end">
            <Title color={isOverLimit ? theme.palette.danger.default : undefined}>
              {characterCount} / 25 characters {isOverLimit && "(Too long for Slack)"}
            </Title>
          </Stack>
        </Stack>

        {/* Description */}
        <Stack vertical gap="xSmall">
          <Title style={{ fontSize: "14px" }}>Description</Title>
          <HtmlEditor
            content={description ?? undefined}
            onChange={desc => onChange(title, desc)}
            placeholder="Enter form description"
          />
        </Stack>
      </Stack>
    </Card>
  );
};
